import React from 'react';
import { toggleStatus, showPopup } from '../../../helpers/uiFunctions/uiActions';

class BlogFilters extends React.Component {
    render() {
        return(
            <div className="list-tabs">
                <div className="tab active" id="blog-tab-1" onClick={() => toggleStatus("all", "blog-tab-1", "blogs")}>All</div>
                <div className="tab" id="blog-tab-2" onClick={() => toggleStatus("paused", "blog-tab-2", "blogs")}>Scheduled</div>
                <div className="tab" id="blog-tab-3" onClick={() => toggleStatus("up", "blog-tab-3", "blogs")}>Published</div>
                <div className="tab" id="blog-tab-4" onClick={() => toggleStatus("down", "blog-tab-4", "blogs")}>Ended</div>
                <div className="tab new" onClick={() => showPopup("addBlogForm")}>New Blog</div>
            </div>
        )
    }
}
export default BlogFilters;


// WEBPACK FOOTER //
// ./src/component_blog/components/BlogExplorer/BlogFilters.js